/**
 * Created by 枯荣<panjiankang@cai-inc.com> on 2019-08-27 13:53.
 */
const BaseCategoryPage = require( 'base/category-page' );
const Server = require( 'helper/server' );

class ZcyWuhaiCategory extends BaseCategoryPage {
  constructor() {
    super( {
      events: {
        'click .search-btn': 'handleSearch',
        'click .reset-btn': 'handleReset',
        'click .expand': 'handleExpand',
        'click .collapse': 'handleCollapse'
      }
    } );
    this.procurementMenuMode = [];
    this.initPage();

  }

  initPage() {
    this.initDate();
    this.initHeighSearch();
  }

  async initHeighSearch() {
    const payload = {
      queryWithCode: true,
      includeAllNode: false,
      includeSelf: false
    };
    const { data: districtList } = await Server.getAnnouncementDistrict( payload );
    const $root = $( '.block__search form' );
    const district = $root.find( 'select[name="districtCode"]' );
    let options = '<option value="">请选择</option>';
    $.map( districtList, ( item ) => {
      options += `<option value="${ item.code }">${ item.name }</option>`;
    } );
    district.html( options );
    this.procurementMenuMode = await Server.queryProcurementMenuMode();
  }

  initDate() {
    const $date = $( '.date-range .date' );
    $date.datetimepicker( {
      format: 'yyyy-mm-dd',
      autoclose: true,
      maxView: 4,
      minView: 2,
      language: 'zh-CN'
    } );
  }

  search() {
    const { showContent, code } = this.selectedTreeNode;
    const $form = this.$el.find( '.block__search_wrap' );
    const formItem = $form.find( '.form_item' );
    const query = this.query.params || {};
    const payload = {
      ...query,
      categoryCode: code,
      pageSize: this.pageSize,
      pageNo: this.pageNo
    };
    $.map( formItem, ( item ) => {
      const key = $( item ).attr( 'name' );
      const value = $( item ).val();
      if (value !== '' && value !== null) {
        if (key === 'districtCode') {
          if (payload[ key ]) {
            payload[ key ].push( value );
          } else {
            payload[ key ] = [ value ];
          }
          ;
        } else {
          payload[ key ] = value;
        }
      }

    } );
    Server.searchCategory( payload ).then( res => {
      this.renderList( res );
    } );
  }

  handleSearch() {
    this.search();
  }

  handleReset() {
    const $form = this.$el.find( '.block__search_wrap' );
    $form[ 0 ].reset();
    this.search();
  }

  handleExpand() {
    const $root = $( '.block__search form' );
    const procurement = $root.find( 'select[name="procurementMethodCode"]' );
    let options = '<option value="">请选择</option>';
    $.map( this.procurementMenuMode, ( item ) => {
      options += `<option value="${ item.code }">${ item.name }</option>`;
    } );
    procurement.html( options );
    $( '.block__search' ).animate( {
      height: '186px'
    }, 100, '', () => {
      // $( '.block__search' ).css( 'overflow', 'unset' );
      $( '.block__search' ).removeClass( 'overHiden' );
    } );
    this.$el.find( '.expand, .collapse' ).toggle();
  }

  handleCollapse() {
    $( '.block__search' ).addClass( 'overHiden' );
    $( '.block__search' ).animate( {
      height: '64px',
      overflow: 'hidden'
    }, 100 );
    this.$el.find( '.expand, .collapse' ).toggle();
  }

}

module.exports = ZcyWuhaiCategory;
